import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SfaQualificationCriteriaContainerModel } from "../../../../../models/aggregates/sfa/SfaQualificationCriteriaHdrContainer.model";
import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { Core2Config } from "../shared/core2Config";

@Injectable({
	providedIn: "root",
})
export class SfaQualificationCriteriaService extends BaseApiTemplateService<SfaQualificationCriteriaContainerModel> {
	readonly url =
		Core2Config.TENANT_DOMAIN_URL_PREFIX +
		Core2Config.SFA_MODULE_PREFIX +
		"qualification-criteria";

	constructor(http: HttpClient) {
		super();
		this.apiUrl =
			Core2Config.DOMAIN_URL +
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.SFA_MODULE_PREFIX +
			"qualification-criteria";
		this.endpoint_path =
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.SFA_MODULE_PREFIX +
			"qualification-criteria";
		this.httpClient = http;
	}
}
